<div class="main-div-payment" *ngIf="isUserLoggedIn">
    <div class="skeleton" *ngIf="paymentSuccessSkeleton">
        <div
            class="animated-background"
            style="
                height: 94vh;
                border: 2px solid white;
                width: auto;
                box-sizing: border-box;
            "
        ></div>
    </div>
    <div
        class="checkoutpayment_successpage"
        *ngIf="!paymentSuccessSkeleton"
        has-header="true"
        scroll="false"
    >
        <div class="page-side-space">
            <div class="checkoutpayment_successcontent">
                <div class="payment-success-messageblock">
                    <div class="payment-success-emoticon">
                        <img
                            [src]="
                                orderdata.orderStatus === 'Completed'
                                    ? 'assets/icons/checkout/success/check-green.png'
                                    : 'assets/icons/checkout/success/check.png'
                            "
                        />
                    </div>
                    <div
                        *ngIf="orderdata.orderStatus === 'Completed'"
                        class="payment-success-msg"
                    >
                        <p>
                            {{ "Order placed, thanks!" | translate }}
                        </p>
                        <p>
                            {{
                                "Check your email for your Booking Confirmation."
                                    | translate
                            }}
                        </p>
                        <p>
                            {{
                                "Estimated delivery within 2 minutes"
                                    | translate
                            }}
                        </p>
                        <div class="checkoutorderpreview-table">
                            <div class="table-preview-div">
                                <div *ngIf="orderdata.orderNumber > 0">
                                    <div class="invoice-left-div">
                                        <label class="invoice-label">
                                            {{ "Order Number" | translate }}
                                        </label>
                                    </div>
                                    <div class="invoice-right-div">
                                        <label class="invoice-label">
                                            {{ orderdata.orderNumber }}
                                        </label>
                                    </div>
                                </div>
                                <div *ngIf="orderdata.name">
                                    <div class="invoice-left-div">
                                        <label class="invoice-label">
                                            {{ "Name" | translate }}
                                        </label>
                                    </div>
                                    <div class="invoice-right-div">
                                        <label class="invoice-label">
                                            {{ orderdata.name }}
                                        </label>
                                    </div>
                                    <div class="invoice-left-div">
                                        <label class="invoice-label">
                                            {{ "Email Address" | translate }}
                                        </label>
                                    </div>
                                    <div class="invoice-right-div">
                                        <label class="invoice-label">
                                            {{ orderdata.email }}
                                        </label>
                                    </div>
                                </div>
                                <div *ngIf="orderdata.orderStatus">
                                    <div class="invoice-left-div">
                                        <label class="invoice-label">
                                            {{ "Payment status" | translate }}
                                        </label>
                                    </div>
                                    <div class="invoice-right-div">
                                        <label class="invoice-label">
                                            {{
                                                statusDisplayMap[
                                                    orderdata.orderStatus
                                                ] ?? orderdata.orderStatus
                                            }}
                                        </label>
                                    </div>
                                </div>
                                <div>
                                    <div class="invoice-left-div">
                                        <label class="invoice-label">
                                            {{ "Amount Payable" | translate }}
                                        </label>
                                    </div>
                                    <div class="invoice-right-div">
                                        <label class="invoice-label">
                                            {{
                                                orderdata.amount
                                                    | currency
                                                        : currencySymbol
                                                        : "symbol"
                                                        : "1.0-0"
                                                        : locale
                                            }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="payment-success-msg"
                        *ngIf="
                            orderdata.orderStatus?.toLowerCase() === 'pending'
                        "
                    >
                        <p>
                            {{ "Order Received" | translate }}
                        </p>
                        <p>
                            {{ "Thank you, " | translate }} {{ orderdata.name }}
                        </p>
                        <p>
                            {{ "Your order has been received." | translate }}
                            #{{ orderdata.orderNumber }}
                        </p>
                        <p>
                            {{ "A summary has been sent to" | translate }}
                            {{ orderdata.email }}
                        </p>
                        <div class="su-pa-m">
                            <img
                                class="s-p-icon"
                                src="assets/icons/checkout/success/clock-time.png"
                            />
                            <div class="su-pa-s">
                                <div class="su-pa-b">
                                    <div class="su-pa-b-p">
                                        {{ "Payment Status" | translate }}:
                                    </div>
                                    <div class="su-pa-b-v">
                                        {{ orderdata.orderStatus }}
                                    </div>
                                </div>
                                <div>
                                    <div
                                        class="su-pa-b-t"
                                        [innerHTML]="
                                            'orderNotConfirmed'
                                                | translate
                                        "
                                    ></div>
                                </div>
                            </div>
                        </div>
                        <div class="su-pa-b-a">
                            <p class="su-pa-b-i">
                                {{ "Choose a Payment Method" | translate }}
                            </p>
                            <div class="su-pa-qr-c">
                                <img
                                    class="qr-i"
                                    src="assets/icons/checkout/success/juice-qr.jpg"
                                />
                                <div class="qr-c-m">
                                    <div class="qr-c-t">
                                        {{
                                            "Mobile Payment via QR Code"
                                                | translate
                                        }}
                                    </div>
                                    <div class="qr-c-s">
                                        {{
                                            "Scan the QR code to proceed"
                                                | translate
                                        }}.
                                    </div>
                                </div>
                            </div>
                            <div class="su-pa-qr-c">
                                <img
                                    class="qr-i"
                                    src="assets/icons/checkout/success/card-dummy.png"
                                />
                                <div class="qr-c-m card-c">
                                    <div class="qr-c-t">
                                        {{ "Pay by Credit Card" | translate }}
                                    </div>
                                    <div class="qr-c-s">
                                        {{
                                            "Secure online payment" | translate
                                        }}.
                                    </div>
                                    <button>
                                        <a
                                            href="https://page.peachpayments.com/mari-deal"
                                        >
                                            {{
                                                "Proceed to Payment" | translate
                                            }}
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="su-pa-int-m">
                            <div class="int-title">
                                <img
                                    src="assets/icons/checkout/success/bank-icon.png"
                                />
                                <div>
                                    {{ "Internet Banking" | translate }}
                                </div>
                            </div>
                            <div class="int-sub">
                                {{
                                    "Extra charges as per Bank's norms"
                                        | translate
                                }}
                            </div>
                            <div class="int-sub-b">
                                Mauritius Commercial Bank Ltd
                            </div>
                            <div class="int-sub-b-c">
                                {{ "Bank Account" | translate }}: 000442345917
                            </div>
                            <div class="int-sub-b-c">
                                {{ "Beneficiary Name" | translate }}: Mari Deal
                                Ltd
                            </div>
                            <div class="int-sub-b">
                                State Bank of Mauritius Ltd
                            </div>
                            <div class="int-sub-b-c">
                                {{ "Bank Account" | translate }}: 62030100185095
                            </div>
                            <div class="int-sub-b-c">
                                {{ "Beneficiary Name" | translate }}: Mari Deal
                                Ltd
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="
                            orderdata.orderStatus ===
                            'Payment_completed_but_place_order_failed'
                        "
                        class="payment-success-msg"
                    >
                        <p>
                            {{ "Payment Successful!" | translate }}
                        </p>
                        <p>
                            {{
                                "Your order is being processed. An agent will contact you or you can call our hotline on 263-27-69"
                                    | translate
                            }}
                            .
                        </p>
                    </div>
                </div>

                <div class="height30"></div>
                <div class="securecheckout_textblock"></div>
                <button
                    class="button button-block button-positiveBtn-rounded continue-shopping ripleEffect"
                    (click)="continueShoping()"
                >
                    {{ "Home Page" | translate }}
                </button>
                <div class="success-help">
                    <div>{{ "Need help?" | translate }}</div>
                    <a
                        href="https://marideal.freshdesk.com/support/tickets/new"
                        >{{ "Contact Support" | translate }}</a
                    >
                </div>
            </div>
        </div>
    </div>
</div>
